// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","429":"component---src-pages-projects-js","670":"component---src-pages-work-js"}[chunkId] || chunkId) + "-" + {"293":"c31ed902b0c8e7242267","429":"be7f48b1c429e579ebbb","454":"fb7ef47da43f1ddb5b80","670":"ab429028ac71afdfcb69"}[chunkId] + ".js";
};